import { Avatar, Flex, List, Typography } from "antd";
import { EducationalBackgroundInterface } from "api/enumerator/Profile/dto";
import dayjs from "dayjs";
import { formatDate } from "utils/date";
const { Text } = Typography;

interface EducationItemProps {
  item: EducationalBackgroundInterface;
}

export const EducationItem = ({ item }: EducationItemProps) => (
  <List.Item>
    <List.Item.Meta
      avatar={
        <Avatar size={50} style={{ backgroundColor: "#22AD5C" }}>
          {item?.institutionName[0]?.toUpperCase()}
        </Avatar>
      }
      title={<span style={{fontSize: '1.25rem', fontWeight: 'bold'}}>{item.institutionName}</span>}
        description={
        <Flex vertical>
          <Text type="secondary">
            {item?.degree} in {item?.fieldOfStudy}
          </Text>
          <Text type="secondary">
            {item.startDate && formatDate(dayjs(item?.startDate.toDate()))} -{" "}
            {item?.endDate && formatDate(dayjs(item?.endDate.toDate()))}
          </Text>
        </Flex>
      }
    />
  </List.Item>
);